/* pes-events.js - PES storefront events -> Intercom trackEvent -> pes-intercom-bridge (identity -> Odoo).
Consent-aware (Shopify Customer Privacy), no PII values, once-per-URL. BRIDGE_URL dark for now. */
(function () {
'use strict';
var BRIDGE_URL = ''; // set to bridge base URL when /webhooks/storefront is redeployed
var w = window, d = document, fired = {};
function consentOk() {
try {
var S = w.Shopify;
if (S && S.customerPrivacy && S.customerPrivacy.analyticsProcessingAllowed) return S.customerPrivacy.analyticsProcessingAllowed();
if (S && S.consent && S.consent.current && typeof S.consent.current.analytics !== 'undefined') return !!S.consent.current.analytics;
} catch (e) {}
return true;
}
function send(name, meta) {
if (!consentOk() || typeof w.Intercom !== 'function') return;
(meta = meta || {}).source = 'storefront';
meta.path = w.location.pathname;
try { w.Intercom('trackEvent', name, meta); } catch (e) {}
if (BRIDGE_URL && navigator.sendBeacon) {
try {
navigator.sendBeacon(BRIDGE_URL + '/webhooks/storefront',
new Blob([JSON.stringify({ event: name, meta: meta, ts: Date.now() })], { type: 'application/json' }));
} catch (e) {}
}
}
function once(k, name, meta) { if (!fired[k]) { fired[k] = 1; send(name, meta); } }
function fromUrl(pfx) { return (w.location.pathname.split(pfx)[1] || '').split(/[?#/]/)[0]; }
function productInfo() {
var r = { handle: fromUrl('/products/'), vendor: '', price: '', sku: '' }, ns = d.querySelectorAll('script[type="application/ld+json"]');
for (var i = 0; i < ns.length; i++) try {
var L = JSON.parse(ns[i].textContent); L = Array.isArray(L) ? L : [L];
for (var j = 0; j < L.length; j++) {
var n = L[j];
if (n && n['@type'] === 'Product') {
var o = n.offers && (Array.isArray(n.offers) ? n.offers[0] : n.offers);
r.vendor = (n.brand && (n.brand.name || n.brand)) || ''; r.price = (o && o.price) || ''; r.sku = n.sku || '';
return r;
}
}
} catch (e) {}
return r;
}
function cardHandle(el) {
var c = el.closest && el.closest('[data-product-handle], .card-wrapper, .product-card, li, article');
if (c) {
var h = c.getAttribute('data-product-handle');
if (h) return h;
var a = c.querySelector && c.querySelector('a[href*="/products/"]');
if (a) { var m = a.getAttribute('href').match(/\/products\/([^?#]+)/); if (m) return m[1]; }
}
return fromUrl('/products/');
}
function quoteKind(f) { return !f ? null : f.id === 'QuoteWizardForm' ? 'quote-wizard' : f.id === 'pes-rfq-form' ? 'rfq-page' : null; }
function rfqProduct(f) {
var el = f && f.querySelector('#rfq-product, [name*="product"]');
return el && el.value ? String(el.value).slice(0, 120) : '';
}
function firePageview() {
var p = w.location.pathname;
if (p.indexOf('/products/') !== -1) {
var r = productInfo();
once('pv:' + p, 'pes-product-view', { handle: r.handle, vendor: String(r.vendor), price: String(r.price), sku: String(r.sku) });
} else if (p.indexOf('/collections/') !== -1) {
once('cv:' + p, 'pes-collection-view', { handle: fromUrl('/collections/') });
} else if (p === '/search') {
var q = new URLSearchParams(w.location.search).get('q') || '';
once('srp:' + p + q, 'pes-search', { query: q.slice(0, 120), results_page: true });
}
}
d.addEventListener('click', function (e) {
var t = e.target && e.target.closest ? e.target : null;
if (!t) return;
var call = t.closest('.pes-oos-btn--call'), em = call ? null : t.closest('.pes-oos-btn--email');
if (call || em) return send('pes-oos-cta-click', { action: call ? 'call' : 'email', product: cardHandle(call || em) });
if (t.closest('#rfq-submit-btn')) send('pes-quote-form-submit', { form: 'rfq-page', product: rfqProduct(d.getElementById('pes-rfq-form')) });
}, true);
d.addEventListener('focusin', function (e) {
var f = e.target && e.target.closest ? e.target.closest('form') : null;
var k = quoteKind(f);
if (k) once('qfs:' + k + ':' + w.location.pathname, 'pes-quote-form-start', { form: k, product: rfqProduct(f) });
}, true);
d.addEventListener('submit', function (e) {
var f = e.target;
if (!f) return;
var k = quoteKind(f);
if (k) return send('pes-quote-form-submit', { form: k, product: rfqProduct(f) });
if (f.classList && f.classList.contains('pes-bis-form')) return send('pes-bis-signup', { product: (f.id || '').replace(/^pes-bis-/, '') });
var act = (f.getAttribute && f.getAttribute('action')) || '';
if (act.indexOf('/search') !== -1) {
var inp = f.querySelector('input[name="q"], input[type="search"]');
var v = inp && inp.value ? String(inp.value).slice(0, 120) : '';
if (v) send('pes-search', { query: v, results_page: false });
}
}, true);
var navTimer = null;
function onNav() { clearTimeout(navTimer); navTimer = setTimeout(firePageview, 800); }
['pushState', 'replaceState'].forEach(function (m) {
var orig = history[m];
if (typeof orig === 'function') history[m] = function () { var r = orig.apply(this, arguments); onNav(); return r; };
});
w.addEventListener('popstate', onNav);
if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', firePageview);
else firePageview();
})();
